import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';

export const Title = styled(Typography)`
  text-transform: uppercase;
  text-align: center;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h4};
    margin: 0 ${theme.spacing(2)} ${theme.spacing(2)};
  `}
`;

export const Body = styled(Box)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.regular};
    padding: ${theme.spacing(2, 2, 0, 2)};
    scale: ${theme.fontSizes.p0};
    color: ${theme.colors.defaultAdd3};
    line-height: ${theme.lineHeights.p0};
  `}
`;

export const Desc = styled(Box)`
  text-align: center;
  ${({ theme }) => css`
    padding: ${theme.spacing(2)};
    color: ${theme.colors.default};
  `}
`;
